import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { ApiError, httpClient } from '@/api/http-client'

export async function acceptProposal(dealKey: string) {
  const response = await httpClient('accounting-dealer').put<void>(
    `/v3/deal/${dealKey}/proposal`,
    undefined,
    { ignoreErrorToast: true },
  )

  return response.data
}

export function useAcceptProposal(
  options?: UseMutationOptions<unknown, ApiError, string, unknown>,
) {
  return useMutation({
    mutationFn: acceptProposal,
    ...options,
  })
}
